<script>
  import backend from "~/backend"
  import { writable } from "svelte/store"

  export let chain

  const currentStreak = writable(chain.current_streak)
  const maxStreak = writable(chain.max_streak)

  function persistChanges(chain) {
    const payload = chain.dates.map((date) => {
      return {
        date: date.date,
        completed: date.completed
      }
    })

    backend.updateChain(chain.id, { dates: payload }, (response) => {
      currentStreak.set(response.data.current_streak)
      maxStreak.set(response.data.max_streak)
    })
  }

  let timer
  const debouncedUpdate = (chain) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      persistChanges(chain)
    }, 500)
  }

  $: debouncedUpdate(chain)
</script>

<main>
  <div
    class="pl-4 py-2 space-y-1 border-l-4 {chain.dates.every(
      (date) => date.completed
    )
      ? 'border-success'
      : 'border-danger'}"
  >
    <div class="flex">
      <a href="/chains/timeline" class="text-sm flex-grow">{chain.name}</a>
      <div
        class="text-sm font-semibold {$currentStreak == $maxStreak
          ? 'text-success'
          : 'text-danger'}"
      >
        {$currentStreak}
      </div>
      <div class="text-sm font-medium ml-1">({$maxStreak})</div>
    </div>
    <div class="flex items-center">
      {#each chain.dates as date (date.id)}
        <div class="flex" title={date.date}>
          <input
            id={date.id}
            type="checkbox"
            class="cursor-pointer checkbox-input"
            bind:checked={date.completed}
          />
          <label for={date.id}>
            <span class="cursor-pointer checkbox checkbox-success"
              >{date.label}</span
            >
          </label>
        </div>
      {/each}
    </div>
  </div>
</main>

<style>
  .checkbox {
    @apply flex w-6 h-6 cursor-pointer items-center justify-center text-xs;
  }
  .checkbox:after {
    @apply w-6 h-6;
  }
</style>
